/* unplugin-vue-components disabled */import { render } from "./campus.vue?vue&type=template&id=6d159456&scoped=true"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"

import "./campus.vue?vue&type=style&index=0&id=6d159456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d159456"]])

export default __exports__